import { classes } from 'html-classes';
import { forwardRef } from 'react';

import { useDateItem } from '~/components/ModalSlotsSelectDate/hooks';

import styles from './DateItem.module.scss';

export interface DateItemProps {
  timeStamp: string;
  onClick?: () => void;
  selected?: boolean;
}

const DateItem = forwardRef<HTMLDivElement, DateItemProps>(
  ({ timeStamp, onClick, selected }, ref) => {
    const { day } = useDateItem({ timeStamp });

    return (
      <div
        className={classes([styles.root, selected && styles.selected])}
        role="tab"
        tabIndex={-1}
        onClick={onClick}
        ref={ref}
      >
        {day}
      </div>
    );
  },
);

DateItem.displayName = 'DateItem';

export default DateItem;
